// extracted by mini-css-extract-plugin
export default {"level-selector":"AssignHeadModal_level-selector__IANKP"};